var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloud = function SvgCloud(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.115 16.707a1 1 0 0 0-1.407-.156L17 17.919v-4.587a1 1 0 0 0-2 0v4.587l-1.71-1.368a1 1 0 1 0-1.249 1.562l3.33 2.664a.996.996 0 0 0 1.262-.004l3.326-2.66a1 1 0 0 0 .155-1.406"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.28 9.714a7.062 7.062 0 0 1 12.979 3.39 5.85 5.85 0 1 1 .226 11.694H9.333A7.666 7.666 0 1 1 11.28 9.714m5.933-1.23a5.06 5.06 0 0 0-4.563 2.867 1 1 0 0 1-1.262.496 5.666 5.666 0 1 0-2.055 10.95h15.15a3.848 3.848 0 0 0 3.271-5.883 3.85 3.85 0 0 0-4.268-1.684 1 1 0 0 1-1.25-1.083 5.06 5.06 0 0 0-5.026-5.663z",
    clipRule: "evenodd"
  })));
};
export default SvgCloud;